import React from "react";
import Loading from "components/Loading";
import TreeMap from "components/TreeMap";
import { useSchemaIndexListTreeMapQuery } from "./gql/Query.generated";
import styles from "./style.module.scss";
import { useRoutes } from "utils/routes";

interface Props {
  databaseId: string;
}

const IndexTreeMap: React.FunctionComponent<Props> = ({ databaseId }) => {
  const { databaseIndex } = useRoutes();
  const { data, loading, error } = useSchemaIndexListTreeMapQuery({
    variables: { databaseId },
  });
  if (loading || error) {
    return <Loading error={!!error} />;
  }

  const treeMapData = data.getSchemaIndices.map(({ id, name, sizeBytes }) => ({
    name: name,
    link: databaseIndex(databaseId, id),
    size: sizeBytes || 0,
  }));

  return <TreeMap className={styles.treemap} data={treeMapData} />;
};

export default IndexTreeMap;
